(function(angular){
	'use strict';
	
	var contentImageObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			aliasCssClasses: '@?',
			source: '<',
			altProp: '@?',
			wrapperCssClasses: '@?'
		},
		controller: [ContentImageFunction],
		controllerAs: 'contentImage'
	};
	
	angular
		.module('imageLazyModule')
		.component('contentImage', contentImageObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/image-lazy/content-image.html';
	}
	
	function ContentImageFunction(){
		var contentImage = this;

		contentImage.$onInit = function() {
			contentImage.cssClasses = contentImage.cssClasses || 'aspect-ratio-16-9';
		};
	}
})(window.angular);